const api_end_point = "https://tcagenda2023.s.cmshelp.dk/AgendaList/";
//const api_end_point = "https://conferenceapiagenda.s.cmshelp.dk/AgendaList/";
//const api_end_point = "https://localhost:44352/AgendaList/";
export default {
    api_end_point: api_end_point,
    filers: api_end_point + "GetFilter?eventName=gastech",
    category_list_api: api_end_point + "GetCategoryList?eventName=gastech",
    agenda_detail_api: api_end_point + "GetAgendaDataByIdAll?eventName=gastech",
    user_detail_api: api_end_point + "GetAgendaUserByUserId",
 
    initial_load_api: () => `${api_end_point}GetAllAgendaDataAllGastech?eventName=gastech`,
    date_list_api: () => `${api_end_point}GetDateListAll?eventName=gastech`,
};


